import { useEffect, useState } from 'react';
import { getMenuAPI } from '../api/AccountSetup';
import { useMenuContext } from '../Contexts/MenuContext';

const getCustomMenuEffect = (uuid: string) => {
  const { updateMenu } = useMenuContext();
  const [menu, setMenu] = useState<string[]>([]);
  const [menuUuid, setMenuUuid] = useState();

  const fetchData = async () => {
    try {
      const res = await getMenuAPI(uuid);
      updateMenu(res.payload.metaData);
      setMenu(res.payload.metaData);
      setMenuUuid(res.payload.uuid);
    } catch (error) {
      console.error('Error fetching menu:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { menu, menuUuid, fetchData };
};

export default getCustomMenuEffect;
